<div class="either-of-input" (click)="stopPropagation($event)">
  <span class="either-of-chip" *ngFor="let value of values">
    <span class="either-of-chip-text" [title]="value">{{ value }}</span>
    <button type="button" class="either-of-chip-remove" (click)="removeValue(value); $event.stopPropagation()" aria-label="Remove value">
      ×
    </button>
  </span>
  <input
    class="either-of-field"
    type="text"
    [(ngModel)]="draft"
    [placeholder]="values.length ? '' : placeholderText"
    (keydown)="handleKeydown($event)"
    (paste)="handlePaste($event)"
    (blur)="handleBlur()"
    (click)="stopPropagation($event)"
  />
</div>
